export default __webpack_public_path__ + "static/media/Holo90.1a606e2b.gif";